import type { CSSProperties, KeyboardEventHandler, MouseEventHandler } from 'react';
import { frameTimecode } from '../../domain/frame-timecode';

export function TimelineTransition({ label, start, end, duration, left, width, top, selected, dragging, arrival = true, action, id, onKeyDown, onContextMenu }: {
  label: string; start: number; end: number; duration: number; left: number; width: number; top: number;
  selected: boolean; dragging?: boolean; arrival?: boolean; action: 'scene-transition' | 'attribute-transition'; id: string;
  onKeyDown: KeyboardEventHandler<HTMLButtonElement>; onContextMenu?: MouseEventHandler<HTMLSpanElement> | undefined;
}) {
  const edge = arrival ? start : end, frame = Math.round(edge / duration * (duration * 30 - 1));
  const keyFrame = Math.round((arrival ? end : start) / duration * (duration * 30 - 1));
  return <span className="timeline-transition-region" role="group" aria-label={`${label} transition ${(end - start).toFixed(2)} seconds`}
    data-timeline-action={action === 'attribute-transition' ? 'attribute' : 'waypoint'} data-id={id} data-frame={keyFrame}
    data-selected={selected} data-dragging={dragging} data-start-seconds={start} data-duration-seconds={end - start} data-end-seconds={end}
    onContextMenu={onContextMenu} title={`${frameTimecode(frame)} · ${(end - start).toFixed(2)}s transition · Drag the ${arrival ? 'start' : 'end'} handle to change duration`}
    style={{ left, width, top } as CSSProperties}>
    <button type="button" className="timeline-transition-edge" data-edge={arrival ? 'start' : 'end'} draggable={false}
      style={{ left: arrival ? -14 : 'calc(100% - 14px)' }} aria-label={`${label} transition ${arrival ? 'start' : 'end'}`}
      data-timeline-action={action} data-id={id} data-frame={frame} onKeyDown={onKeyDown}>
      <span className="timeline-transition-grip" aria-hidden="true" />
    </button>
  </span>;
}
